import _ from 'lodash'

export const BACKGROUND_STYLES_KEYS = [
  'background',
  'backgroundColor',
  'backgroundImage',
  'backgroundSize',
  'backgroundPosition',
  'backgroundRepeat',
  'backgroundAttachment',
  'backgroundClip',
]

export const BORDER_KEYS = [
  'borderColor',
  'borderWidth',
  'borderStyle',
  'borderRadius',
  '--ft-border',
  ..._.flatMap(['Top', 'Left', 'Bottom', 'Right'], (v) => [`border${v}Style`, `border${v}Color`, `border${v}Width`]),
]

export const SPREAD_CONTENT_OMIT = [
  ...BACKGROUND_STYLES_KEYS,
  'paddingLeft',
  'paddingTop',
  'paddingRight',
  'paddingBottom',
  'marginLeft',
  'marginRight',
  'marginTop',
  'marginBottom',
  ...BORDER_KEYS,
]

export const SPREAD_CONTENT_PREVIEW_OMIT = [
  'paddingLeft',
  'paddingTop',
  'paddingRight',
  'paddingBottom',
  'marginLeft',
  'marginRight',
  'marginTop',
  'marginBottom',
]
